import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import VilatteProductCard from './VilatteProductCard';

const VilattePromo = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/vilatte/featured?limit=3', { signal: controller.signal })
      .then((response) => response.ok ? response.json() : Promise.reject(new Error('feed unavailable')))
      .then((data) => setProducts((data.products || []).slice(0, 3)))
      .catch(() => setProducts([]));
    return () => controller.abort();
  }, []);

  return (
    <section className="container vilatte-promo-section" aria-labelledby="vilatte-promo-title">
      <div className="vilatte-promo-copy">
        <p className="vilatte-kicker">VILATTE · ОПТОВЫЕ ЦЕНЫ</p>
        <h2 id="vilatte-promo-title">VILATTE по оптовым ценам</h2>
        <p>Современная одежда с продуманной посадкой. Много моделей из хлопка, вискозы, шерсти и кашемира. Выкупаем напрямую у VILATTE по оптовым ценам.</p>
        <ul>
          <li>Текущие размеры и остатки</li>
          <li>Быстрая доставка</li>
        </ul>
        <Link className="vilatte-primary-link" to="/vilatte">Смотреть каталог</Link>
        <nav className="vilatte-home-sections" aria-label="Разделы каталога Вилатте">
          {['Женщинам','Мужчинам','Дети'].map(section => <Link key={section} to={`/vilatte?section=${encodeURIComponent(section)}`}>{section}</Link>)}
          <Link to="/vilatte?new=1">Новинки</Link>
        </nav>
      </div>
      {products.length > 0 && (
        <div className="vilatte-promo-products">
          {products.map((product) => (
            <VilatteProductCard compact key={product.external_id} product={product} onOpen={() => navigate((product.product_url || `/vilatte/${encodeURIComponent(product.external_id)}`))} />
          ))}
        </div>
      )}
    </section>
  );
};

export default VilattePromo;
